{
  "CapabilitiesAffected": "Fonctionnalités affectées :",
  "ShowRelated": "Afficher {relatedCount} connexes"
}
